import React from 'react';
import { FormField, Select, ISelectProps } from '@cian/ui-kit';

export interface IRealtorRatingFieldPeriod {
  options: ISelectProps['options'];
  value?: ISelectProps['value'];
  onChange?: ISelectProps['onChange'];
  disabled?: ISelectProps['disabled'];
}

/**
 * Филд Период
 */
export const RealtorRatingFieldPeriod = ({ value, options, disabled, onChange }: IRealtorRatingFieldPeriod) => (
  <FormField label={'Период'}>
    <Select size={'M'} value={value} options={options} disabled={disabled} onChange={onChange} />
  </FormField>
);
